<template>
  <div>
    <breadcrumbs
      :breadcrumb-items="breadcrumbItems"
    />
    <UserToolbar
      v-if="account && Object.keys(account).length !== 0"
      :account="account"
    />
    <b-card>
      <CreativeToolbar
        :banner="banner"
        closing
      />
    </b-card>

    <CreativeNavigation v-if="authUserData.role.includes('admin')" />

    <b-card class="card-statistics">
      <div class="card-statistics-tools">
        <h4>{{ $t('Statistics') }}</h4>
      </div>
      <div class="mt-2">
        <CreativeDateRangeFilter
          :value="rangePicker"
          :is-loading="loading"
          @refresh="getstatsV2Data"
          @input="toggleRange"
        />
        <b-row
          v-if="statsV2Data.length !== 0"
          class="row-statistics"
        >
          <b-col
            md="12"
            cols="12"
          >
            <CreativeStatsTable
              :account="account"
              :stats-data="statsV2Data"
              :campaign-type="campaign.type"
              :account-currency="account.currency"
              :selected-range="selectedRangeFormated"
            />
          </b-col>
        </b-row>
        <div
          v-else-if="graphicShow && statsV2Data.length === 0"
          class="card-nodata"
        >
          <p class="card-text">
            {{ $t('sites.nodata_period') }}
          </p>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import { getUserData } from '@/auth/utils'
import Ripple from 'vue-ripple-directive'
import getFormattedDate, { getFormattedDateMonth } from '@/utils/date-formatter'
import currencyFormatter from '@/utils/currency-formatter'
import useJwt from '@/auth/jwt/useJwt'
import {
  BCard,
  BRow,
  BCol,
} from 'bootstrap-vue'
import Breadcrumbs from '@/views/ui/breadcrumbs/Breadcrumbs.vue'
import UserToolbar from '@/views/dashboard/users/UserToolbar.vue'
import CreativeToolbar from './CreativeToolbar.vue'
import CreativeStatsTable from './stats/CreativeStatsTableV2.vue'
import CreativeNavigation from './CreativeNavigation.vue'
import CreativeDateRangeFilter from './CreativeDateRangeFilter.vue'

export default {
  components: {
    Breadcrumbs,
    UserToolbar,
    BCard,
    BRow,
    BCol,
    CreativeToolbar,
    CreativeDateRangeFilter,
    CreativeStatsTable,
    CreativeNavigation,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loading: false,
      breadcrumbItems: [],
      account: {},
      campaign: {},
      banner: {},
      blockSubtitle: '',
      authUserData: getUserData(),
      currency: currencyFormatter,
      getFormattedDate,
      getFormattedDateMonth,
      statsV2Data: [],
      typeText: {
        month: this.$i18n.t('30 days'),
        week: this.$i18n.t('7 days'),
        day: this.$i18n.t('1 day'),
      },
      numDays: {
        month: 30,
        week: 7,
        day: 1,
      },
      graphicShow: false,
      rangePicker: [],
      rangeDefault: [
        getFormattedDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1)),
        getFormattedDate(new Date()),
      ],
    }
  },
  computed: {
    processedData() {
      return this.statsV2Data.map(item => {
        const { revenue, clicks, ...rest } = item

        const revenueSum = Object.values(revenue).reduce((acc, value) => acc + value, 0)
        const clicksSum = Object.values(clicks).reduce((acc, value) => acc + value, 0)

        return {
          ...rest,
          revenue: revenueSum,
          clicks: clicksSum,
        }
      })
    },
    selectedRangeFormated() {
      let dateFrom
      let dateTo
      const selectedRange = this.rangePicker
      if (Array.isArray(selectedRange) && selectedRange.length > 0) {
        [dateFrom, dateTo] = selectedRange
      } else {
        [dateFrom, , dateTo] = selectedRange.split(' ')
      }

      return {
        from: getFormattedDate(new Date(dateFrom)),
        to: dateTo === undefined ? getFormattedDate(new Date(dateFrom)) : getFormattedDate(new Date(dateTo)),
      }
    },
  },
  created() {
    this.rangePicker = this.rangeDefault
    this.getUser()
    this.getCampaignData()
    this.blockSubtitle = `${this.selectedRangeFormated.from.replaceAll('-', '.')}-${this.selectedRangeFormated.to.replaceAll('-', '.')}`
  },
  methods: {
    toggleRange(selectedDates) {
      this.rangePicker = selectedDates
      this.blockSubtitle = `${this.selectedRangeFormated.from.replaceAll('-', '.')}-${this.selectedRangeFormated.to.replaceAll('-', '.')}`
      this.getstatsV2Data()
    },
    async getstatsV2Data() {
      this.loading = true
      this.statsV2Data = []

      let params
      let reqParams
      let responseData

      if (this.campaign.type !== undefined && this.campaign.type !== 'default' && this.campaign.type !== 'news') {
        const ecpmParams = {
          campaign_id: this.$route.params.id,
          type: 'daily',
          ad_type: this.campaign.type,
        }
        reqParams = Object.assign(ecpmParams, this.selectedRangeFormated)
        responseData = await useJwt.getCreativeStatsEcpm(ecpmParams)
      } else {
        params = {
          campaign_id: this.$route.params.id,
          ad_id: this.$route.params.bannerId,
          type: 'daily',
        }
        reqParams = Object.assign(params, this.selectedRangeFormated)
        responseData = await useJwt.getCreativeStatsByTypeV2(reqParams)
      }

      this.statsV2Data = responseData.data.items || []
      this.loading = false
    },
    async getCampaignData() {
      const responseData = await useJwt.getCampaign(this.$route.params.id)
      this.campaign = responseData.data.campaign || {}
      this.getstatsV2Data()
      await this.getBannerData()
      this.setBreabcrumbs()
    },
    async getBannerData() {
      const responseData = await useJwt.getBanner(this.$route.params.bannerId)
      this.banner = responseData.data.banner || {}
    },
    async getUser() {
      const responseData = await useJwt.getUser(this.$route.params.userId)
      this.account = responseData.data.account || {}
    },
    setBreabcrumbs() {
      this.breadcrumbItems = [
        {
          text: 'users',
          to: '/users',
        },
        {
          text: this.account.name,
          to: `/users/${this.$route.params.userId}`,
        },
        {
          text: 'Campaigns',
          to: `/users/${this.$route.params.userId}/campaigns`,
        },
        {
          text: this.campaign.title,
          to: `/users/${this.$route.params.userId}/campaigns/${this.$route.params.id}`,
        },
        {
          text: 'Creatives',
          to: `/users/${this.$route.params.userId}/campaigns/${this.$route.params.id}/creatives`,
        },
        {
          text: this.banner.title || 'Creative',
          active: true,
        },
      ]
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style scoped lang="scss">
.card-statistics-tools {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

@media (max-width: 440px) {
  [dir] #app {
    .card-statistics-tools {
      flex-wrap: wrap;
    }
  }
}
</style>
